import React from "react";
import Modal from "react-responsive-modal";
import LanguageStringResolver from "../fields/language/LanguageStringResolver";
import BulkTransactionErrorDetails from "./BulkTransactionErrorDetails";
import { CSVLink } from "react-csv";
import { sanitizeCsvData } from "../../utils/csvSanitizer";

const MODAL_CLASSNAMES = {
    modal: "custom-modal-class",
    overlay: "custom-overlay-class",
};

const ModalContainer = ({ children, showModal, onClose }) => {
    return (
        <Modal
            open={showModal}
            onClose={onClose}
            classNames={MODAL_CLASSNAMES}
            closeOnEsc={true}
            blockScroll={true}
            closeOnOverlayClick={false}
        >
            {children}
        </Modal>
    );
};

const DownloadButton = ({ data }) => {
    if (!data?.entities) {
        return null;
    }

    const fileName = "BulkOperation_ErrorDetails.csv";
    const csvData = data.entities
        .filter(entity => entity.status === "Failed")
        .map((entity) => {
            return {
                EntityId: entity.entityId,
                Reason: entity.reason
            };
        });
    return (
        <CSVLink data={sanitizeCsvData(csvData)} filename={fileName} className="button secondary mt20" data-testid="error-details-download-button">
            <LanguageStringResolver string="Label_BulkOperation_ErrorsDownloadButton" />
        </CSVLink>
    );
}

const BulkTransactionErrorModal = ({ operation, showModal, onClose }) => {
    if (!operation) {
        return null;
    }

    return (
        <ModalContainer showModal={showModal} onClose={onClose}>
            <h2>
                <LanguageStringResolver string="Title_BulkTransaction_FailedEntities" />
            </h2>
            <BulkTransactionErrorDetails operation={operation} />
            <DownloadButton data={operation} />
        </ModalContainer>
    );
};




export default BulkTransactionErrorModal;